import {db,workspaceAccount} from '../db';
import type {PrivilegeMap} from '../../types';
import {PhotoUploadQueue} from './uploadQueue';
import {photoUploadTransport} from './uploadTransport';
import type {UploadReview} from './uploadTypes';
export interface PhotoUploadAccess {account:string;scope:string;active:boolean;admin:boolean;farms:string[];privileges:Partial<PrivilegeMap>}
let access:PhotoUploadAccess={account:'',scope:'signed-out',active:false,admin:false,farms:[],privileges:{}};
const queues=new WeakMap<typeof db,PhotoUploadQueue>();let activeQueue:PhotoUploadQueue|undefined;
export const uploadChanged=()=>window.dispatchEvent(new Event('sonata-photo-uploads-updated'));
export function canUploadPhoto(review:UploadReview){
 const c=review.destination,p=access.privileges;
 if(!access.active||(!access.admin&&!access.farms.includes(c.farmId)))return false;
 if(c.kind==='route')return !!p.gpsTracking?.view&&!!p.communityParticipation?.write;
 if(c.kind==='place')return !!p.communityParticipation?.write&&!!p.communityParticipation?.view&&!!p.map?.view;
 if(c.kind==='document')return !!p.documents?.view&&!!p.documents?.write;
 if(!p.scouting?.write)return false;
 if(c.kind==='nature')return !!p.communityParticipation?.write&&!!p.communityParticipation?.view&&!!p.map?.view;
 if(c.kind==='project')return !!p.projects?.write&&!!p.projects?.view;
 if(c.kind==='asset')return !!p.assets?.write&&!!p.assets?.view;
 return false;
}
export function setPhotoUploadAccess(next:PhotoUploadAccess){if(access.scope!==next.scope)activeQueue?.stop();access=next;uploadChanged();}
export function originalPhotoUploads(){
 const database=db,account=access.account;
 if(!account||account.toLowerCase()!==workspaceAccount)throw new Error('Photo uploads are waiting for your account.');
 if(!queues.has(database))queues.set(database,new PhotoUploadQueue(database,photoUploadTransport,()=>({account:access.account,scope:access.scope,canUpload:canUploadPhoto}),()=>db===database&&access.account===account,()=>navigator.onLine,uploadChanged,()=>{window.dispatchEvent(new Event('sonata-journal-updated'));window.dispatchEvent(new Event('sonata-photo-completed'));}));
 activeQueue=queues.get(database)!;return activeQueue;
}
export function stopPhotoUploads(){activeQueue?.stop();}
